import Home from "@components/home";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import MainLayout from "../layouts/main/MainLayout";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MainLayout>
      <Home />
    </MainLayout>
  );
}
